export const TOKENS_LOCAL_STORAGE_KEY = "tokens";
export const SELECTED_PLANT_LOCAL_STORAGE_KEY = "selectedPlantMeterId";
